let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dopc8")).then(() => parcelRequire('8fG30'));